import { API, axiosInstance } from "lib";

export const getUserContact = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId || "");
  queryParams.append("userIdToFetch", data?.userIdToFetch || "");
  queryParams.append("page", data?.page || "");
  queryParams.append("limit", data?.limit || "");
  queryParams.append("keyword", data?.keyword || "");
  if (
    data?.isRegistered !== undefined &&
    data?.isRegistered !== null &&
    data?.isRegistered !== ""
  ) {
    queryParams.append("isRegistered", data.isRegistered);
  }
  //   queryParams.append('startDate', data?.startDate);
  //   queryParams.append('endDate', data?.endDate);

  return axiosInstance
    .get(`${API.GET_USER_CONTACT}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};
